import { Link } from "react-router-dom";
import { ArrowLeft, Snowflake } from "lucide-react";

const Eisstockregeln = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-sky-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 md:py-14">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sky-700 hover:text-sky-900 mb-6"
          data-testid="rules-back-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="flex items-center gap-3 mb-3">
          <Snowflake className="w-8 h-8 text-sky-600" />
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900" style={{ fontFamily: "Playfair Display" }}>
            Eisstockregeln
          </h1>
        </div>
        <p className="text-slate-600 mb-10">
          Alles was du wissen musst, um bei uns auf der Eisbahn loszulegen – einfach erklärt und schnell verstanden.
        </p>

        <div className="bg-white rounded-2xl shadow-sm border border-sky-100 p-6 md:p-10 space-y-8">
          {/* 1 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">1</span>
              Spielmaterial
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li><strong>Eisstöcke:</strong> Jeder Spieler oder jedes Team hat Eisstöcke, die über die Eisbahn geschossen werden.</li>
              <li><strong>Daube:</strong> Ein kleiner Zielpunkt, auf den die Spieler ihre Stöcke richten.</li>
              <li><strong>Zielbahn:</strong> Eine glatte Eisbahn, auf der das Spiel stattfindet.</li>
            </ul>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">2</span>
              Teams
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Üblicherweise spielen zwei Teams gegeneinander.</li>
              <li>Jedes Team besteht aus 4 Spielern, jeder mit einem Eisstock.</li>
            </ul>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">3</span>
              Ziel des Spiels
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Ziel ist es, die Eisstöcke möglichst nah an die Daube zu schießen.</li>
              <li>Am Ende jeder Runde werden die Punkte anhand der Position der Stöcke zur Daube vergeben.</li>
            </ul>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">4</span>
              Spielfeld und Startlinie
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Die Daube wird auf der gegenüberliegenden Seite der Bahn positioniert.</li>
              <li>Die Startlinie markiert den Punkt, von dem aus die Spieler ihre Stöcke werfen.</li>
            </ul>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">5</span>
              Ablauf einer Runde
            </h2>
            <ol className="list-decimal list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Die Teams schießen abwechselnd ihre Eisstöcke über die Eisbahn in Richtung Daube.</li>
              <li>Jeder Spieler darf pro Runde einmal schießen.</li>
              <li>Während des Spiels können die Eisstöcke der Gegner weggeschoben oder die Position der Daube verändert werden.</li>
              <li>Eine Runde ist vorbei, wenn alle Spieler eines Teams ihre Stöcke geworfen haben.</li>
            </ol>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">6</span>
              Wertung
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Nach jeder Runde wird bewertet, welcher Eisstock am nächsten an der Daube liegt.</li>
              <li>Nur das Team, dessen Stock am nächsten an der Daube ist, erhält Punkte.</li>
              <li>Es gibt Punkte für den nächsten, zweitnächsten und drittnächsten Eisstock.</li>
              <li>Die Anzahl der Punkte kann variieren, wird jedoch in der Regel auf maximal 3 Punkte pro Runde beschränkt.</li>
            </ul>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">7</span>
              Spielsieg
            </h2>
            <p className="text-slate-700 leading-relaxed pl-4">
              Gespielt wird in der Regel bis eine festgelegte Punktzahl (z.&nbsp;B. 15 Punkte) erreicht ist, oder auf eine bestimmte Anzahl an Runden.
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-sky-100 text-sky-700 text-sm font-bold">8</span>
              Fairplay
            </h2>
            <ul className="list-disc list-inside text-slate-700 space-y-1 pl-4 leading-relaxed">
              <li>Spieler dürfen keine Hilfsmittel oder externe Gegenstände verwenden.</li>
              <li>Alle Spieler sollten respektvoll und fair miteinander umgehen.</li>
            </ul>
          </section>
        </div>

        <p className="text-center text-sm text-slate-500 mt-10">
          Viel Spaß beim Spielen – wir wünschen dir ein gutes Auge und ruhige Hand! 🥌
        </p>
      </div>
    </div>
  );
};

export default Eisstockregeln;
